import React, { useState } from 'react';
import { Button, Space, Typography } from 'antd';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';

const { Text } = Typography;

export default function VoteButtons({ up, down, userVote, dealId, onVote }) {
  const [loading, setLoading] = useState(false);

  const handleVote = async (voteType) => {
    if (!onVote || loading) return;
    setLoading(true);
    try {
      await onVote(dealId, voteType);
    } finally {
      setLoading(false);
    }
  };

  const total = (up || 0) - (down || 0);

  return (
    <Space size={4} role="group" aria-label="Deal votes">
      <Button
        type="text"
        size="small"
        icon={<CaretUpOutlined />}
        loading={loading}
        aria-label="Upvote"
        aria-pressed={userVote === 1}
        style={{
          color: userVote === 1 ? 'var(--df-success, #0F7B5A)' : 'var(--df-text-muted, #8494A7)',
          fontSize: 16,
          width: 40,
          height: 40,
          minWidth: 40,
          borderRadius: 8,
        }}
        onClick={(e) => { e.stopPropagation(); handleVote(1); }}
      />
      <Text
        aria-live="polite"
        style={{
          fontWeight: 700,
          fontSize: 14,
          fontFamily: 'var(--df-font-display, Sora, sans-serif)',
          minWidth: 28,
          textAlign: 'center',
          color: total > 0 ? 'var(--df-success, #0F7B5A)' : total < 0 ? 'var(--df-error, #C0392B)' : 'var(--df-text-secondary, #5B6B7C)',
        }}
      >
        {total}
      </Text>
      <Button
        type="text"
        size="small"
        icon={<CaretDownOutlined />}
        loading={loading}
        aria-label="Downvote"
        aria-pressed={userVote === -1}
        style={{
          color: userVote === -1 ? 'var(--df-error, #C0392B)' : 'var(--df-text-muted, #8494A7)',
          fontSize: 16,
          width: 40,
          height: 40,
          minWidth: 40,
          borderRadius: 8,
        }}
        onClick={(e) => { e.stopPropagation(); handleVote(-1); }}
      />
    </Space>
  );
}
